(function () {
  function pad2(n){ return String(n).padStart(2,'0'); }
  function nextEvergreenTarget(periodHours){
    var now = new Date();
    var ms = periodHours * 3600 * 1000;
    return new Date(Math.ceil(now.getTime()/ms)*ms);
  }
  function parseEnd(dtStr){
    if(!dtStr) return null;
    // 兼容 iOS：把 2024-12-20 00:00 转为 2024/12/20 00:00
    return new Date(dtStr.replace(/-/g,'/'));
  }

  function initCountdown(el){
    var mode   = el.dataset.mode || 'evergreen';          // 'evergreen' | 'fixed'
    var period = parseInt(el.dataset.periodHours || '2', 10);
    var target = (mode === 'evergreen')
      ? nextEvergreenTarget(period)
      : parseEnd(el.dataset.end);

    // 若时间无效，直接隐藏
    if(mode !== 'evergreen' && (!target || isNaN(target.getTime()))){
      el.classList.add('is-done'); return;
    }

    function finish(){
      el.classList.add('is-done');           // 交给 CSS 隐藏
      el.setAttribute('aria-hidden','true');
    }

    var timer = null; // 将 timer 提升到外部作用域
    
    function update(){
      var now  = new Date();
      var diff = target - now;

      if (diff <= 0){
        if (mode === 'evergreen'){
          target = nextEvergreenTarget(period);   // 常绿：重置到下个整周期
          diff   = target - now;
        } else {
          if (timer) clearInterval(timer);       // 固定：结束后隐藏
          finish();
          return;
        }
      }

      var d = Math.floor(diff/86400000);
      var h = Math.floor((diff%86400000)/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var s = Math.floor((diff%60000)/1000);

      // 安全地查找和更新元素，避免 iOS Safari 中的错误
      var q = function(sel){ return el.querySelector(sel); };
      var daysEl = q('[data-cd="days"]');
      var hoursEl = q('[data-cd="hours"]');
      var minutesEl = q('[data-cd="minutes"]');
      var secondsEl = q('[data-cd="seconds"]');
      
      // 只有当元素存在时才更新，避免在 iOS 上因元素未渲染而报错
      if(daysEl) daysEl.textContent = pad2(d);
      if(hoursEl) hoursEl.textContent = pad2(h);
      if(minutesEl) minutesEl.textContent = pad2(m);
      if(secondsEl) secondsEl.textContent = pad2(s);
    }

    // 延迟初始化，确保 DOM 元素完全渲染（特别是 iOS Safari）
    // 使用 requestAnimationFrame 确保在浏览器下一次重绘前执行
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          update();
          timer = setInterval(update, 1000);
          // 将 timer 保存到元素上，以便后续清理
          el._countdownTimer = timer;
        });
      });
    } else {
      // 降级方案：使用 setTimeout
      setTimeout(function() {
        update();
        timer = setInterval(update, 1000);
        el._countdownTimer = timer;
      }, 100);
    }
  }

  function boot(){
    var elements = document.querySelectorAll('.community-countdown');
    if (elements.length === 0) {
      // 如果元素还没加载，稍后重试（针对 iOS Safari 的特殊情况）
      setTimeout(boot, 100);
      return;
    }
    elements.forEach(initCountdown);
  }
  
  // 使用多种方式确保脚本在正确的时机执行
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // 如果文档已经加载完成，立即执行
    setTimeout(boot, 0);
  } else {
    // 否则等待 DOMContentLoaded
    document.addEventListener('DOMContentLoaded', boot);
  }
  
  // 额外的保险：在 window.onload 时也尝试执行（针对某些 iOS Safari 情况）
  window.addEventListener('load', function() {
    setTimeout(function() {
      document.querySelectorAll('.community-countdown').forEach(function(el) {
        if (!el._countdownTimer) {
          initCountdown(el);
        }
      });
    }, 50);
  });
})();
